import React, { createContext, useContext, useState, ReactNode, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../../../../../store/reducers/rootReducer'
import { IUser } from '../../../../../modules/API/Auth/models/authDataModel'
import { startOfMonth, startOfWeek, subWeeks } from 'date-fns'
import selectBrodMigdal from '../../../../../generic/utils/selectBrodMigdal'

type ProblemStateContextType = {
  date: Date[]
  setDate: React.Dispatch<React.SetStateAction<Date[]>>
  isAllowToApprove: boolean,
  user: IUser
  daysPast: number
}

const ProblemStateContext = createContext<ProblemStateContextType | undefined>(undefined)

type ProblemStateProviderProps = {
  children: ReactNode
}
const weekBefore = subWeeks(new Date(), 1)
const initialDate = [new Date(weekBefore), new Date()]

export const ProblemStateProvider: React.FC<ProblemStateProviderProps> = ({ children }) => {
  const defaults = useSelector((state: RootState) => state.defaults?.defaults)
  const [date, setDate] = useState<Date[]>(initialDate)
  const user = useSelector((state: RootState) => state.mainReducer.user) as IUser
  
  const isAllowToApprove = useMemo(() => {
    return user?.rights.includes('SELLER') || user?.rights.includes('OFFICE')
  }, [user])

  const daysPast = useMemo(() => {
    return selectBrodMigdal(defaults, 663, "Num_Value")
  }, [defaults])

  const value = {
    date,
    setDate,
    isAllowToApprove,
    user,
    daysPast
  }

  return (
    <ProblemStateContext.Provider value={value}>
      {children}
    </ProblemStateContext.Provider>
  )
}

export const useProblemStateManager = (): ProblemStateContextType => {
  const context = useContext(ProblemStateContext)
  if (context === undefined) {
    throw new Error('useProblemStateManager must be used within a ProblemStateProvider')
  }
  return context
} 